import { ParallaxComponent } from './parallax.component';

export default angular
  .module('sfMobile.components.parallax', [])
  .component('sfParallax', ParallaxComponent).name;
